import 'vite/modulepreload-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import CheckInChallenge from '@/components/CheckInChallenge';

const rootElement = document.getElementById('check-in-challenge');
if (rootElement) {
  const customerId = rootElement.getAttribute('data-customer-id');
  const customerEmail = rootElement.getAttribute('data-customer-email');
  const eventStart = rootElement.getAttribute('data-event-start');
  const eventEnd = rootElement.getAttribute('data-event-end');
  const eventName = rootElement.getAttribute('data-event-name');
  const token = rootElement.getAttribute('data-token');
  const testToken = rootElement.getAttribute('data-test-token');
  const locale = rootElement.getAttribute('data-locale');
  const totalDays = rootElement.getAttribute('data-total-days');
  const widgetTitle = rootElement.getAttribute('data-widget-title');
  const loginUrl = rootElement.getAttribute('data-login-url');
  const loginToPlay = rootElement.getAttribute('data-login-to-play');

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <CheckInChallenge
        customerId={customerId}
        customerEmail={customerEmail}
        token={token}
        locale={locale}
        testToken={testToken}
        eventName={eventName}
        eventStart={eventStart}
        eventEnd={eventEnd}
        totalDays={totalDays}
        widgetTitle={widgetTitle}
        loginUrl={loginUrl}
        loginToPlay={loginToPlay}
      />
    </React.StrictMode>,
  );
}